/**
 * 初始化服务
 * 处理登录成功后的初始化操作
 */

import userService from './userService';
import teamService from './teamService';
import { getCurrentUser } from './authService';

// 判断是否使用本地模拟数据
const VITE_USE_MOCK_DATA = import.meta.env.VITE_USE_MOCK_DATA === 'true';

const initService = {
  /**
   * 登录成功后的初始化操作
   * @returns {Promise<Object>} - 初始化结果
   */
  initializeAfterLogin: async () => {
    try {
      console.log('开始执行登录后初始化操作...');
      
      // 获取当前用户信息
      const currentUser = getCurrentUser();
      if (!currentUser || !currentUser.id) {
  
        return {
          success: false,
          error: '未获取到用户信息'
        };
      }



      // 并行执行初始化操作
      const initPromises = [
        // 1. 获取用户详细信息
        userService.getUserDetail(currentUser.id).catch(error => {
          console.error('获取用户详情失败:', error);
          return null;
        }),
        
        // 2. 获取用户个人团队列表
        teamService.getUserTeams(currentUser.id).catch(error => {
          console.error('获取用户团队列表失败:', error);
          return { teams: [], groups: [] };
        })
      ];

      // 等待所有初始化操作完成
      const [userDetail, userTeams] = await Promise.all(initPromises);



      // 将初始化数据存储到 localStorage 或全局状态
      const initData = {
        userDetail,
        userTeams: userTeams.groups || userTeams.teams || [], // 兼容两种字段名
        initializedAt: new Date().toISOString()
      };

      // 存储到 localStorage 供其他组件使用
      localStorage.setItem('syntrust_init_data', JSON.stringify(initData));

      // 如果使用mock数据，添加一些额外的初始化逻辑
      if (VITE_USE_MOCK_DATA) {
        console.log('Mock模式：添加额外的初始化数据');
        
        // 可以在这里添加一些mock数据的初始化逻辑
        // 比如设置默认的工作区、菜单状态等
      }

      return {
        success: true,
        data: initData
      };

    } catch (error) {
      console.error('初始化操作失败:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  /**
   * 获取初始化数据
   * @returns {Object|null} - 初始化数据
   */
  getInitData: () => {
    try {
      const initDataStr = localStorage.getItem('syntrust_init_data');
      if (initDataStr) {
        return JSON.parse(initDataStr);
      }
      return null;
    } catch (error) {
      console.error('获取初始化数据失败:', error);
      return null;
    }
  },

  /**
   * 清除初始化数据
   */
  clearInitData: () => {
    localStorage.removeItem('syntrust_init_data');
  },

  /**
   * 检查是否需要重新初始化
   * @returns {boolean} - 是否需要重新初始化
   */
  needsReinitialization: () => {
    const initData = initService.getInitData();
    if (!initData) {
      return true;
    }

    // 检查初始化时间，如果超过30分钟则重新初始化（缩短时间，确保数据更及时）
    const initializedAt = new Date(initData.initializedAt);
    const now = new Date();
    const minutesDiff = (now - initializedAt) / (1000 * 60);
    return minutesDiff > 30;
  },

  /**
   * 强制重新初始化
   * @returns {Promise<Object>} - 重新初始化结果
   */
  reinitialize: async () => {
    console.log('强制重新初始化...');
    // initService.clearInitData();
    // return await initService.initializeAfterLogin();
  }
};

export default initService; 